import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faEye,
  faEyeSlash,
  faFire,
  faCircle,
  faStar,
  faSort,
  faSortUp,
  faSortDown,
  faCog,
  faCalendar,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import '../styles/AdminMovieSettings.css';

const AdminMovieSettings = () => {
  const [movies, setMovies] = useState([]);
  const [filteredMovies, setFilteredMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterVisibility, setFilterVisibility] = useState('all');
  const [filterHot, setFilterHot] = useState('all');

  // Mock movies data with verified working anime poster images
  const mockMovies = [
    {
      id: 1,
      name: 'One Piece',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BODcwNWE3OTMtMDc3MS00NDFjLWE1OTAtNDU3NjgxODMxY2UyXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
      current_episodes: 1000,
      total_episodes: 0,
      view_count: 2500000,
      rating: 9.5,
      year: 2023,
      status: 'ongoing',
      is_visible: true,
      is_hot: true,
      hot_order: 1,
      updated_at: '2024-01-20',
      created_at: '2024-01-15'
    },
    {
      id: 2,
      name: 'Attack on Titan',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BNzc5MTczNDQtNDFjNi00ZDU0LTk2ODQtMzQzYTliYjY4YTZmXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
      current_episodes: 75,
      total_episodes: 75,
      view_count: 1800000,
      rating: 9.2,
      year: 2023,
      status: 'completed',
      is_visible: true,
      is_hot: true,
      hot_order: 2,
      updated_at: '2024-01-18',
      created_at: '2024-01-12'
    },
    {
      id: 3,
      name: 'Demon Slayer: Kimetsu no Yaiba',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZjZjNzI5MDctY2Y4YS00NmM4LTljMmItZTFkOTExNGI3ODRhXkEyXkFqcGdeQXVyNjc3MjQzNTI@._V1_.jpg',
      current_episodes: 32,
      total_episodes: 44,
      view_count: 1200000,
      rating: 8.8,
      year: 2023,
      status: 'ongoing',
      is_visible: true,
      is_hot: true,
      hot_order: 3,
      updated_at: '2024-01-16',
      created_at: '2024-01-10'
    },
    {
      id: 4,
      name: 'Jujutsu Kaisen',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BNGY4MTg3NzgtMmFkZi00NTg5LWExMmEtMWI3YzI1ODdmMWQ1XkEyXkFqcGdeQXVyMjQwMDg0Ng@@._V1_.jpg',
      current_episodes: 24,
      total_episodes: 24,
      view_count: 1500000,
      rating: 9.0,
      year: 2023,
      status: 'completed',
      is_visible: true,
      is_hot: true,
      hot_order: 4,
      updated_at: '2024-01-12',
      created_at: '2024-01-05'
    },
    {
      id: 5,
      name: 'My Hero Academia',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BNjRmNDI5MjMtMmFhZi00OGEyLWE4M2MtOGU4OTJiOGNlN2Q4XkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_.jpg',
      current_episodes: 138,
      total_episodes: 0,
      view_count: 1800000,
      rating: 8.7,
      year: 2023,
      status: 'ongoing',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-19',
      created_at: '2024-01-08'
    },
    {
      id: 6,
      name: 'Naruto Shippuden',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZGFiMWFhNDAtMzUyZS00NmQ2LTljNDYtMmZjNTc5MDUxMzViXkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_.jpg',
      current_episodes: 500,
      total_episodes: 500,
      view_count: 3200000,
      rating: 9.3,
      year: 2022,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-15',
      created_at: '2024-01-01'
    },
    {
      id: 7,
      name: 'Dragon Ball Super',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BMjkxZGNjOWQtOGViOC00MWUxLTgwNzctZGVmNzY2NjIwNzJkXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
      current_episodes: 131,
      total_episodes: 131,
      view_count: 2800000,
      rating: 8.9,
      year: 2023,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-17',
      created_at: '2024-01-03'
    },
    {
      id: 8,
      name: 'Tokyo Ghoul',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BMGNkMWEwN2QtNzU2MS00M2RjLWFhN2MtZjUyMzE4MTE2M2NlXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
      current_episodes: 48,
      total_episodes: 48,
      view_count: 1100000,
      rating: 8.4,
      year: 2022,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-13',
      created_at: '2024-01-02'
    },
    {
      id: 9,
      name: 'Death Note',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BNjRiNzExMzMtMzQ2ZS00OWExLWFhNDAtNTWhNWE1N2M5NDdmXkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_.jpg',
      current_episodes: 37,
      total_episodes: 37,
      view_count: 2100000,
      rating: 9.4,
      year: 2022,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-11',
      created_at: '2024-01-01'
    },
    {
      id: 10,
      name: 'Fullmetal Alchemist: Brotherhood',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZmEzN2YzOTItMDI5MS00MGU4LWI1NWQtOTg5ZThhNGQwYTEzXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
      current_episodes: 64,
      total_episodes: 64,
      view_count: 1900000,
      rating: 9.6,
      year: 2022,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-14',
      created_at: '2024-01-02'
    },
    {
      id: 11,
      name: 'Spy x Family',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZGE1MDg5M2MtNTMwMC00MzI4LTlkNTUtM2FlYWE5MWZkYzhjXkEyXkFqcGdeQXVyMTEzMTI1Mjk3._V1_.jpg',
      current_episodes: 25,
      total_episodes: 0,
      view_count: 1600000,
      rating: 8.9,
      year: 2023,
      status: 'ongoing',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-18',
      created_at: '2024-01-06'
    },
    {
      id: 12,
      name: 'Chainsaw Man',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZTM3ZTU1ZWYtYzllZC00ODRhLTlhNWYtZGY0N2ZkMGQ5YTMwXkEyXkFqcGdeQXVyMTUzMTg2ODkz._V1_.jpg',
      current_episodes: 12,
      total_episodes: 12,
      view_count: 1300000,
      rating: 8.6,
      year: 2023,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-16',
      created_at: '2024-01-07'
    },
    {
      id: 13,
      name: 'Hunter x Hunter',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZjNmZDhkN2QtNDYyZC00YzJmLTg0ODUtN2FjNjhhMzE3ZmUxXkEyXkFqcGdeQXVyNjc2NjA5MTU@._V1_.jpg',
      current_episodes: 148,
      total_episodes: 148,
      view_count: 2200000,
      rating: 9.1,
      year: 2022,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-12',
      created_at: '2024-01-01'
    },
    {
      id: 14,
      name: 'Mob Psycho 100',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BNjkzZGVkMDQtNTcyNi00NDE4LWE5YWItMmM4MTlkMzNjZGRhXkEyXkFqcGdeQXVyMzgxODM4NjM@._V1_.jpg',
      current_episodes: 37,
      total_episodes: 37,
      view_count: 950000,
      rating: 8.8,
      year: 2023,
      status: 'completed',
      is_visible: true,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-15',
      created_at: '2024-01-04'
    },
    {
      id: 15,
      name: 'Hidden Test Movie',
      poster_url: '/logo.png',
      current_episodes: 12,
      total_episodes: 12,
      view_count: 50000,
      rating: 7.2,
      year: 2022,
      status: 'completed',
      is_visible: false,
      is_hot: false,
      hot_order: null,
      updated_at: '2024-01-10',
      created_at: '2024-01-01'
    }
  ];

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      setMovies(mockMovies);
      setFilteredMovies(mockMovies);
      setLoading(false);
    }, 1000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    filterAndSortMovies();
  }, [searchTerm, sortField, sortDirection, filterVisibility, filterHot, movies]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterAndSortMovies = () => {
    let filtered = [...movies];

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(movie =>
        movie.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by visibility
    if (filterVisibility !== 'all') {
      filtered = filtered.filter(movie => 
        filterVisibility === 'visible' ? movie.is_visible : !movie.is_visible
      );
    }

    // Filter by hot status
    if (filterHot !== 'all') {
      filtered = filtered.filter(movie => 
        filterHot === 'hot' ? movie.is_hot : !movie.is_hot
      );
    }

    // Sort
    filtered.sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (sortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    setFilteredMovies(filtered);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const handleToggleVisibility = (movieId) => {
    setMovies(movies.map(movie => {
      if (movie.id === movieId) {
        return {
          ...movie,
          is_visible: !movie.is_visible,
          updated_at: new Date().toISOString().split('T')[0]
        };
      }
      return movie;
    }));
  };

  const handleToggleHot = (movieId) => {
    setMovies(movies.map(movie => {
      if (movie.id === movieId) {
        const newIsHot = !movie.is_hot;
        let newHotOrder = null;
        
        if (newIsHot) {
          // Find the highest hot_order and add 1
          const maxOrder = Math.max(...movies.filter(m => m.is_hot && m.id !== movieId).map(m => m.hot_order || 0));
          newHotOrder = maxOrder + 1;
        }
        
        return {
          ...movie,
          is_hot: newIsHot,
          hot_order: newHotOrder,
          updated_at: new Date().toISOString().split('T')[0]
        };
      }
      return movie;
    }));
  };

  const handleChangeHotOrder = (movieId, newOrder) => {
    if (newOrder < 1) return;
    
    setMovies(movies.map(movie => {
      if (movie.id === movieId && movie.is_hot) {
        return {
          ...movie,
          hot_order: parseInt(newOrder),
          updated_at: new Date().toISOString().split('T')[0]
        };
      }
      return movie;
    }));
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('vi-VN');
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'ongoing': return '#10b981';
      case 'completed': return '#3b82f6';
      case 'dropped': return '#ef4444';
      case 'upcoming': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'ongoing': return 'Đang phát';
      case 'completed': return 'Hoàn thành';
      case 'dropped': return 'Tạm dừng';
      case 'upcoming': return 'Sắp chiếu';
      default: return 'Không xác định';
    }
  };

  if (loading) {
    return (
      <div className="admin-movie-settings">
        <div className="settings-loading">
          <div className="loading-spinner"></div>
          <p>Đang tải danh sách phim...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-movie-settings">
      <div className="settings-header">
        <div className="header-left">
          <h1>
            <FontAwesomeIcon icon={faCog} />
            Tùy chọn Phim
          </h1>
          <p>Quản lý hiển thị và trạng thái hot của các bộ phim</p>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="settings-stats">
        <div className="stat-card">
          <div className="stat-icon success">
            <FontAwesomeIcon icon={faEye} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{movies.filter(m => m.is_visible).length}</div>
            <div className="stat-label">Phim công khai</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon warning">
            <FontAwesomeIcon icon={faEyeSlash} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{movies.filter(m => !m.is_visible).length}</div>
            <div className="stat-label">Phim ẩn</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon hot">
            <FontAwesomeIcon icon={faFire} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{movies.filter(m => m.is_hot).length}</div>
            <div className="stat-label">Phim hot</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon info">
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <div className="stat-content">
            <div className="stat-number">{formatNumber(movies.reduce((sum, m) => sum + m.view_count, 0))}</div>
            <div className="stat-label">Tổng lượt xem</div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="settings-filters">
        <div className="search-box">
          <FontAwesomeIcon icon={faSearch} />
          <input
            type="text"
            placeholder="Tìm kiếm phim..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="filter-group">
          <select 
            value={filterVisibility} 
            onChange={(e) => setFilterVisibility(e.target.value)}
          >
            <option value="all">Tất cả trạng thái</option>
            <option value="visible">Chỉ công khai</option>
            <option value="hidden">Chỉ ẩn</option>
          </select>
          <select 
            value={filterHot} 
            onChange={(e) => setFilterHot(e.target.value)}
          >
            <option value="all">Tất cả hot</option>
            <option value="hot">Chỉ phim hot</option>
            <option value="normal">Chỉ phim thường</option>
          </select>
        </div>
      </div>

      {/* Movies Table */}
      <div className="settings-table-container">
        <table className="settings-table">
          <thead>
            <tr>
              <th>Poster</th>
              <th onClick={() => handleSort('name')} className="sortable">
                Tên phim
                <FontAwesomeIcon 
                  icon={sortField === 'name' ? (sortDirection === 'asc' ? faSortUp : faSortDown) : faSort} 
                />
              </th>
              <th>Thông tin</th>
              <th onClick={() => handleSort('view_count')} className="sortable">
                Lượt xem
                <FontAwesomeIcon 
                  icon={sortField === 'view_count' ? (sortDirection === 'asc' ? faSortUp : faSortDown) : faSort} 
                />
              </th>
              <th onClick={() => handleSort('rating')} className="sortable">
                Đánh giá
                <FontAwesomeIcon 
                  icon={sortField === 'rating' ? (sortDirection === 'asc' ? faSortUp : faSortDown) : faSort} 
                />
              </th>
              <th>Hiển thị</th>
              <th>Hot</th>
              <th>Thứ tự hot</th>
              <th onClick={() => handleSort('updated_at')} className="sortable">
                Cập nhật
                <FontAwesomeIcon 
                  icon={sortField === 'updated_at' ? (sortDirection === 'asc' ? faSortUp : faSortDown) : faSort} 
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredMovies.map(movie => (
              <tr key={movie.id} className={!movie.is_visible ? 'hidden-movie' : ''}>
                <td>
                  <div className="movie-poster">
                    <img 
                      src={movie.poster_url} 
                      alt={movie.name}
                      onError={(e) => {
                        e.target.src = '/logo.png';
                      }}
                    />
                    {movie.is_hot && (
                      <div className="hot-badge">
                        <FontAwesomeIcon icon={faFire} />
                      </div>
                    )}
                  </div>
                </td>
                <td>
                  <div className="movie-info">
                    <div className="movie-name">{movie.name}</div>
                    <div className="movie-details">
                      <span className="episode-info">
                        {movie.current_episodes}/{movie.total_episodes || '?'} tập
                      </span>
                      <span className="year-info">{movie.year}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="status-info">
                    <div 
                      className="status-badge"
                      style={{ backgroundColor: getStatusColor(movie.status) }}
                    >
                      {getStatusText(movie.status)}
                    </div>
                  </div>
                </td>
                <td>
                  <div className="view-count">
                    <FontAwesomeIcon icon={faEye} />
                    <span>{formatNumber(movie.view_count)}</span>
                  </div>
                </td>
                <td>
                  <div className="rating">
                    <FontAwesomeIcon icon={faStar} />
                    <span>{movie.rating}/10</span>
                  </div>
                </td>
                <td>
                  <button 
                    className={`toggle-btn visibility ${movie.is_visible ? 'visible' : 'hidden'}`}
                    onClick={() => handleToggleVisibility(movie.id)}
                    title={movie.is_visible ? 'Ẩn phim' : 'Hiển thị phim'}
                  >
                    <FontAwesomeIcon icon={movie.is_visible ? faEye : faEyeSlash} />
                    {movie.is_visible ? 'Công khai' : 'Ẩn'}
                  </button>
                </td>
                <td>
                                      <button 
                      className={`toggle-btn hot ${movie.is_hot ? 'hot' : 'normal'}`}
                      onClick={() => handleToggleHot(movie.id)}
                      title={movie.is_hot ? 'Bỏ khỏi hot' : 'Thêm vào hot'}
                    >
                      <FontAwesomeIcon icon={movie.is_hot ? faFire : faCircle} />
                      {movie.is_hot ? 'Hot' : 'Thường'}
                    </button>
                </td>
                <td>
                  {movie.is_hot ? (
                    <div className="hot-order">
                      <input
                        type="number"
                        value={movie.hot_order || ''}
                        onChange={(e) => handleChangeHotOrder(movie.id, e.target.value)}
                        min="1"
                        className="order-input"
                      />
                    </div>
                  ) : (
                    <span className="no-order">-</span>
                  )}
                </td>
                <td>
                  <div className="update-date">
                    <FontAwesomeIcon icon={faCalendar} />
                    {formatDate(movie.updated_at)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminMovieSettings;